// extracted by mini-css-extract-plugin
export var dropdownButton = "_37-0";
export var fullWidthDropdownButton = "_37-1";
export var icon = "_37-3";
export var iconPlaceholder = "_37-2";
export var menuItemRow = "_37-9";
export var separator = "_37-e";
export var shortcutContainer = "_37-7";
export var shortcutContainerFilled = "_37-8";
export var shortcutIconLg = "_37-6";
export var shortcutIconMd = "_37-5";
export var shortcutIconSm = "_37-4";
export var submenuChevron = "_37-d";
export var submenuDropdown = "_37-a";
export var submenuTriggerRow = "_37-b";
export var submenuTriggerRowOpen = "_37-c";